/*
 * Infinite scroll — loads next page when last post enters viewport.
 * Requires: cards with class `.post`, feed container with class `.gh-postfeed`,
 * and a `<link rel="next">` element in the page head for pagination.
 */

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

async function getNextPage(url) {
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch page');
        const html = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(html, 'text/html');
        const posts = parsed.querySelectorAll('.post');
        const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');
        return { posts, nextLink };
    } catch (error) {
        throw new Error(error);
    }
}

export default function infiniteScroll() {
    if (!link || !document.querySelector('.gh-postfeed')) return;

    const options = { rootMargin: '150px' };

    const callback = (entries, observer) => {
        try {
            entries.forEach(entry => {
                if (entry.isIntersecting && link) {
                    getNextPage(link).then(({ posts, nextLink }) => {
                        posts.forEach(post => {
                            document.querySelector('.gh-postfeed').append(post);
                        });
                        if (nextLink) {
                            link = nextLink;
                            observer.observe(document.querySelector('.post:last-of-type'));
                        } else {
                            observer.disconnect();
                        }
                    });
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const observer = new IntersectionObserver(callback, options);
    const lastPost = document.querySelector('.post:last-of-type');
    if (lastPost) observer.observe(lastPost);
}
